import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {environment} from 'src/environments/environment';
import {Observable} from 'rxjs';
import { UtilService } from 'src/app/service/util';
import { SolicitacaoCompra, SolicitacaoCompraAprovar, SolicitacaoCompraLista, SolicitacaoCompraPendente } from '../interface/solicitacao-compra';
import { IFiltroListaSolicitacaoCompra } from '../filter/filtro-lista-solicitacao-compra';


@Injectable({
  providedIn: 'root'
})
export class SolicitacaoCompraService {

  constructor(
    private http: HttpClient,
    private utilService: UtilService
  ) { }

  url = `${environment.urlApiProtheus}/wsrcomsolicitacaocompra`;


  postSolicitacaoCompra(dados: SolicitacaoCompra): Observable<SolicitacaoCompra> {

    const httpOptions = this.utilService.filtrosHttpOptions();

    return this.http.post<SolicitacaoCompra>(`${this.url}`,dados, httpOptions);

  }

  getSolicitacaoCompraLista(filtro: IFiltroListaSolicitacaoCompra): Observable<SolicitacaoCompraLista> {

    const httpOptions = this.utilService.filtrosHttpOptions(filtro);

    return this.http.get<SolicitacaoCompraLista>(`${this.url}`, httpOptions);

  }

  getSolicitacaoCompra(CC1NUM: string, filtro: {} = {}): Observable<SolicitacaoCompra> {

    const httpOptions = this.utilService.filtrosHttpOptions(filtro);

    return this.http.get<SolicitacaoCompra>(`${this.url}/${CC1NUM}`, httpOptions);

  }

  deleteSolicitacaoCompra(CC1NUM: string): Observable<any> {

    const httpOptions = this.utilService.filtrosHttpOptions();

    return this.http.delete(`${this.url}/${CC1NUM}`, httpOptions);

  }

  getSolicitacaoCompraPendenteLista(filtro: {}): Observable<SolicitacaoCompraPendente> {

    const httpOptions = this.utilService.filtrosHttpOptions(filtro);

    return this.http.get<SolicitacaoCompraPendente>(`${this.url}/pendente`, httpOptions);

  }

  getSolicitacaoCompraAprovarLista(filtro: IFiltroListaSolicitacaoCompra): Observable<SolicitacaoCompraAprovar> {

    const httpOptions = this.utilService.filtrosHttpOptions(filtro);

    return this.http.get<SolicitacaoCompraAprovar>(`${this.url}/aprovar`, httpOptions);

  }

  postSolicitacaoCompraAprovar(dados: SolicitacaoCompraAprovar): Observable<any> {

    const httpOptions = this.utilService.filtrosHttpOptions();

    return this.http.post(`${this.url}/aprovar`,dados, httpOptions);

  }

}
